import { render, staticRenderFns } from "./CategoryParentIds.vue?vue&type=template&id=09ed3603&"
import script from "./CategoryParentIds.vue?vue&type=script&lang=ts&"
export * from "./CategoryParentIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports